"use client";

import { Smartphone, X } from "lucide-react";
import { Button } from "../ui/button";

export default function ArDesktopPrompt({ open, onClose }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-black/70 p-4"
      onClick={onClose}
      role="presentation">
      <div
        className="glass-box relative w-full max-w-md p-6 text-center text-white"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="ar-desktop-prompt-title">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 left-4 rounded-full p-1 text-mute transition hover:text-white"
          aria-label="بستن">
          <X className="h-5 w-5" />
        </button>

        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full border border-white/20">
          <Smartphone className="h-7 w-7" />
        </div>

        <h3 id="ar-desktop-prompt-title" className="mb-2 text-lg font-semibold">
          مشاهده در واقعیت افزوده
        </h3>
        <p className="mb-6 text-sm leading-7 text-mute">
          برای مشاهده محصول در محیط منزل، لطفاً با گوشی موبایل خود وارد این صفحه شوید.
        </p>

        <Button variant="berryBorder" size="lg" className="w-full" onClick={onClose}>
          متوجه شدم
        </Button>
      </div>
    </div>
  );
}
